import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'empty' })
export class EmptyPipe implements PipeTransform {
  transform(input: any, emptyCharacter: string = '—') {
    return input == null || input.length == 0 ? emptyCharacter : input;
  }
}
